//Helper function related fo projects
import PropTypes from "prop-types";

export const projectShape = {
    Project: PropTypes.string.isRequired,
    fundName: PropTypes.string.isRequired,
    Description: PropTypes.string,
    "Total NSW funding": PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]).isRequired,
    "Funding co-contribution": PropTypes.string.isRequired,
    Status: PropTypes.string.isRequired,
    Region: PropTypes.string,
    LGA: PropTypes.string.isRequired,
    Electorate: PropTypes.string.isRequired,
    "Street Address": PropTypes.string.isRequired,
    Latitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    Longitude: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    "Event dates": PropTypes.string,
    "Total funding": PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    "Multiple locations": PropTypes.string,
    "Multiple LGAs": PropTypes.string,
    "ID": PropTypes.string,
    "Multiple ID": PropTypes.string,
    "Round": PropTypes.string,
};

export const ensureLatAndLng = (x) =>
    !String(x.Latitude).includes("°") &&
    !String(x.Longitude).includes("°") &&
    Boolean(parseFloat(x.Latitude)) &&
    Boolean(parseFloat(x.Longitude));

export const centerFromProject = (project) => {
    return [parseFloat(project.Longitude), parseFloat(project.Latitude)];
};



// WEBPACK FOOTER //
// ./src/modules/project.js